module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.googleAnalytics.widget":[{"value":"mcGoogleAnalytics","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.widget":[{"value":"#logoutApi","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101024},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.event":[{"value":"success","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101025},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.callback":[{"value":function () {
var ga = fox.wom.selectFirst('@root #googleAnalytics');
ga.trackEvent({'eventCategory': 'User', 'eventAction': 'logout'});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101029},"path":"@root","_fox_":1}]},"@root #router":{"hooks.onStopExecute":[{"value":function () {
var counterCalls = 0;
var currentPage = this._passedRoute.path;
var self = this;
var callback = function callback () {
counterCalls++;
var loaded = typeof _gaScriptLoaded !== 'undefined' ?
_gaScriptLoaded :
false
if (!loaded && counterCalls < 5) {
return setTimeout(callback, 2000);
}
self.rwom1('@root #googleAnalytics').trackPageview(currentPage, false);
}();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101020},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/ga/options/ga.js
// module id = 29
// module chunks = 5